import {KEY_CODE} from "../../../constants/keycodes";

class PredefinedKey {
    isArrowKey(code) {
        switch(code) {
            case KEY_CODE.ARROW_LEFT:
            case KEY_CODE.ARROW_TOP:
            case KEY_CODE.ARROW_RIGHT:
            case KEY_CODE.ARROW_BOTTOM:
                return true;
        }
        return false;
    }
}

const predefinedKey = new PredefinedKey();

export {predefinedKey}